import React from "react"
import "./nav-button.css"

const NavButton = ({ active = false, children = "导航按钮" }) => {
  return (
    <div className="nav-button">
      <div className={`nav-button-container ${active ? "active" : ""}`}>
        <i className="nav-button-before"></i>
        <div className="nav-button-wrapper">
          <i></i>
          <span>{children}</span>
        </div>
        <i className="nav-button-after"></i>
      </div>
    </div>
  )
}

export default NavButton
